/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'townsquare-comments.comment-action-bar.delete-button': '削除',
  'townsquare-comments.comment-action-bar.edit-button': '編集',
  'townsquare-comments.comment-action-bar.reply-button': '返信',
  'townsquare-comments.comment.edited-date': '{time}に編集',
  'townsquare-comments.comments.comments-title':
    '{itemCount, plural, =0 {コメント数} other {{itemCount,number} 件のコメント}}',
};
